function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Modal } from '@signicat/designi/components/overlays';
import { TextField, Autocomplete } from '@signicat/designi/components/inputs';
import { getUsers } from "../../store/actions/users";
import { searchContacts } from "../../store/actions/contacts";
import { getContactList, getContactListContacts, createContactList, getContactLists, updateContactList } from "../../store/actions/contactLists";
import _ from 'lodash';
import t from "../../scripts/i18n";
import "../../styling/components/list/ListSettings.css";

var ListEdit = function ListEdit(props) {
  var dispatch = useDispatch();
  var id = props.id,
      isEdit = props.isEdit,
      onClose = props.onClose;
  var currentUserId = useSelector(function (state) {
    return state.app.userId;
  });
  var users = useSelector(function (state) {
    return state.users.data;
  });
  var contactsState = useSelector(function (state) {
    return state.contacts;
  });
  var selectedContacts = contactsState.selectedContacts;
  var initialContacts = selectedContacts.map(function (c) {
    return {
      value: c.id,
      text: "".concat(c.firstName, " ").concat(c.lastName)
    };
  });
  var usersOptions = users.filter(function (u) {
    return u.userId !== currentUserId;
  }).map(function (u) {
    return {
      value: u.userId,
      text: "".concat(u.profile.firstName, " ").concat(u.profile.lastName)
    };
  });

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState({
    listName: false,
    contactRequired: false
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      validationErrors = _useState4[0],
      setValidationErrors = _useState4[1];

  var _useState5 = useState(initialContacts),
      _useState6 = _slicedToArray(_useState5, 2),
      contactsOptions = _useState6[0],
      setContactsOptions = _useState6[1];

  var _useState7 = useState(''),
      _useState8 = _slicedToArray(_useState7, 2),
      listName = _useState8[0],
      setListName = _useState8[1];

  var _useState9 = useState(selectedContacts.map(function (c) {
    return c.id;
  })),
      _useState10 = _slicedToArray(_useState9, 2),
      listSelectedContacts = _useState10[0],
      setListSelectedContacts = _useState10[1];

  var _useState11 = useState([]),
      _useState12 = _slicedToArray(_useState11, 2),
      selectedUsers = _useState12[0],
      setSelectedUsers = _useState12[1];

  var handleFormChange = function handleFormChange(e) {
    var value = e.target.value;
    setListName(value);
  };

  var handleContactSearch = _.debounce( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e, value) {
      var _yield$dispatch, data, options;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(value && value.length >= 2)) {
                _context.next = 13;
                break;
              }

              _context.prev = 1;
              _context.next = 4;
              return dispatch(searchContacts({
                wildcard: value,
                limit: 100
              }));

            case 4:
              _yield$dispatch = _context.sent;
              data = _yield$dispatch.data;
              data = data.filter(function (c) {
                return !contactsOptions.map(function (co) {
                  return co.value;
                }).includes(c.id) && !initialContacts.map(function (ic) {
                  return ic.id;
                }).includes(c.id) && !listSelectedContacts.includes(c.id);
              });

              if (data && data.length) {
                options = data.map(function (c) {
                  return {
                    value: c.id,
                    text: "".concat(c.firstName, " ").concat(c.lastName)
                  };
                });
                setContactsOptions([].concat(_toConsumableArray(contactsOptions), _toConsumableArray(options)));
              }

              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);
              console.error(_context.t0);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 10]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(), 400);

  var handleContactsChange = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e, value) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return setListSelectedContacts(value);

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleContactsChange(_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleUsersChange = function handleUsersChange(e, value) {
    setSelectedUsers(value);
  };

  var isFormValid = function isFormValid() {
    var result = {};
    result.listName = !listName;
    result.contactRequired = !listSelectedContacts || listSelectedContacts.length <= 0;
    if (!_.isEqual(result, validationErrors)) setValidationErrors(_objectSpread(_objectSpread({}, validationErrors), result));
    return Object.values(result).every(function (x) {
      return x === false;
    });
  };

  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(e) {
      var contactList;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              e.preventDefault();

              if (!isFormValid()) {
                _context3.next = 17;
                break;
              }

              setLoading(true);
              _context3.prev = 3;
              contactList = {
                id: id,
                name: listName,
                contacts: listSelectedContacts,
                permissions: {
                  groups: null,
                  users: [{
                    id: currentUserId,
                    accessLevel: 0
                  }].concat(_toConsumableArray(selectedUsers.map(function (u) {
                    return {
                      accessLevel: 0,
                      id: u
                    };
                  })))
                }
              };
              _context3.next = 7;
              return dispatch(isEdit ? updateContactList(contactList) : createContactList(contactList));

            case 7:
              dispatch(getContactLists());
              onClose();
              _context3.next = 14;
              break;

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](3);
              console.log(_context3.t0);

            case 14:
              _context3.prev = 14;
              setLoading(false);
              return _context3.finish(14);

            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[3, 11, 14, 17]]);
    }));

    return function handleSubmit(_x5) {
      return _ref3.apply(this, arguments);
    };
  }();

  useEffect(function () {
    if (listName && validationErrors.listName || listSelectedContacts.length && validationErrors.contactRequired) isFormValid();
  }, [listName, listSelectedContacts]);
  useEffect(function () {
    var populateFields = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var contacts, list;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return dispatch(getContactListContacts(id));

              case 2:
                contacts = _context4.sent;
                _context4.next = 5;
                return dispatch(getContactList(id));

              case 5:
                list = _context4.sent;
                setListName(list.name);
                setContactsOptions(contacts.data.filter(function (c) {
                  return list.contacts.includes(c.id);
                }).map(function (c) {
                  return {
                    value: c.id,
                    text: "".concat(c.firstName, " ").concat(c.lastName)
                  };
                }));
                setListSelectedContacts(list.contacts);
                setLoading(false);

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function populateFields() {
        return _ref4.apply(this, arguments);
      };
    }();

    dispatch(getUsers());

    if (id && isEdit) {
      setLoading(true);
      populateFields();
    }
  }, []);

  var validationEl = function validationEl(text) {
    return /*#__PURE__*/React.createElement("div", {
      className: "validation-text"
    }, text);
  };

  return /*#__PURE__*/React.createElement(Modal, {
    size: "md",
    isLoading: loading
  }, /*#__PURE__*/React.createElement("div", {
    className: "list-settings"
  }, /*#__PURE__*/React.createElement("h1", null, t('list_settings')), /*#__PURE__*/React.createElement("div", {
    className: "form"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, t('list_settings_name')), /*#__PURE__*/React.createElement(TextField, {
    id: "name",
    name: "name",
    type: "text",
    onChange: handleFormChange,
    value: listName,
    placeholder: t('list_settings_name_placeholder'),
    style: {
      width: '100%'
    }
  }), validationErrors.listName && validationEl(t('list_settings_name_required'))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, t('list_settings_contacts'), " "), /*#__PURE__*/React.createElement(Autocomplete, {
    key: "asdf",
    multiple: true,
    options: contactsOptions,
    value: listSelectedContacts,
    onChange: handleContactsChange,
    onInputChange: handleContactSearch,
    noOptionsText: t('list_settings_contacts_no_options'),
    style: {
      width: '100%'
    }
  }), validationErrors.contactRequired && validationEl(t('list_settings_at_least_one_contact_required'))), /*#__PURE__*/React.createElement("div", {
    className: "invite-people"
  }, /*#__PURE__*/React.createElement("p", null, t('list_settings_share_list')), /*#__PURE__*/React.createElement(Autocomplete, {
    multiple: true,
    options: usersOptions,
    value: selectedUsers,
    onChange: handleUsersChange,
    style: {
      width: '100%'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "actions"
  }, /*#__PURE__*/React.createElement("button", {
    className: "secondary",
    onClick: onClose
  }, t('list_settings_cancel')), /*#__PURE__*/React.createElement("button", {
    className: "primary",
    onClick: handleSubmit
  }, t('list_settings_submit')))))));
};

export default ListEdit;